import { useState } from "react";

export default function usePopupVisibility() {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [iscrollPopupVisible, setScrollPopupVisible] = useState(false);

  const showPopup = () => setIsPopupVisible(true);
  const hidePopup = () => setIsPopupVisible(false);
  const scrollshowPopup = () => setScrollPopupVisible(true);
  const scrollHidePopup = () => setScrollPopupVisible(false);

  return {
    isPopupVisible,
    showPopup,
    hidePopup,
    iscrollPopupVisible,
    scrollshowPopup,
    scrollHidePopup,
  };
}
